import { Button, Flex, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const handleGoToHome = () => {
    navigate("/");
  };

  return (
    <Flex
      align="center"
      justify="center"
      style={{ flexDirection: "column", height: "100vh" }}
    >
      <Typography.Title level={1}>404</Typography.Title>
      <Typography.Paragraph>
        Sorry, the page you visited does not exist.
      </Typography.Paragraph>
      <Button type="primary" onClick={handleGoToHome}>
        Back Home
      </Button>
    </Flex>
  );
};

export default NotFound;
